import React from 'react';
import { Card, Row, Col, Form, Button } from 'react-bootstrap';
import MaskedInput from 'react-text-mask';
import { MASK_DATE } from '~/constant';

const PainelFiltroData = ({ dataInicialFiltro, onDataChange, onFiltrar, loading }) => (
  <Card className="mb-2">
    <Card.Header className="py-1">
      <strong>Filtrar por Data de Vencimento</strong>
    </Card.Header>
    <Card.Body>
      <Row className="align-items-end">
        <Col md={3}>
          <Form.Group>
            <Form.Label className="small mb-1">Vencimento inicial (dd/mm/aaaa)</Form.Label>
            <MaskedInput
              mask={MASK_DATE}
              guide={false}
              type="tel"
              className="form-control"
              placeholder="dd/mm/aaaa"
              value={dataInicialFiltro}
              onChange={(e) => onDataChange(e.target.value)}
              disabled={loading}
            />
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label className="small mb-1">&nbsp;</Form.Label>
            <Button onClick={onFiltrar} disabled={loading} variant="secondary" block>
              Filtrar
            </Button>
          </Form.Group>
        </Col>
      </Row>
    </Card.Body>
  </Card>
);

export default PainelFiltroData;
